/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d308379a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ql-editor"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    title: {
      type: String,
      default: '参数配置说明'
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    const dialogVisible = ref(false);
    const handleClose = () => {
      dialogVisible.value = false;
    };
    const show = () => {
      dialogVisible.value = true;
    };
    __expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_dialog = __unplugin_components_0;
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        title: __props.title,
        width: "900px",
        "before-close": handleClose
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_renderSlot(_ctx.$slots, "content")])]),
        _: 3
      }, 8, ["modelValue", "title"]);
    };
  }
});